<ten-process-result
  class="popup-member-registration-result"
  result="{{ result }}"
  [useImageIcon]="true"
  *ngIf="variables$ | async as variables"
>
  <div tabindex="0" ten-process-result-body>
    <ng-container *ngIf="result === 'success'">
      <h2 [innerHTML]="variables.homepage_member_acquisition_confirmation_title | translate"></h2>
      <p tabindex="0" [innerHTML]="variables.homepage_member_acquisition_confirmation_body | translate"></p>
    </ng-container>
    <ng-container *ngIf="result !== 'success'">
      <p
        tabindex="0"
        class="px-2"
        [translate]="'ContactConcierge:General'"
        [translateParams]="{
          contact_number_general: variables.contact_number_general
        }"
      ></p>
    </ng-container>
  </div>
  <mat-icon
    ten-process-result-close-icon
    class="close-cross"
    role="button"
    tabindex="0"
    aria-label="close"
    aria-hidden="false"
    (accessibleClick)="close()"
  >
    close
  </mat-icon>
</ten-process-result>
